import { MouseEvent } from "react";
import { getLandingContainer } from "../../../utils/getLandingContainer";
import { IMousePosition } from "src/libs/interfaces/layouts";


export default function getSectionMousePosition(evt: MouseEvent) : IMousePosition {
    let x                           = evt.clientX
    let y                           = evt.clientY
    const landing: HTMLDivElement   = getLandingContainer() as HTMLDivElement
    const section                   = (evt.target as any).closest(".landing-section-container.landing-gap[id]")
    if( !landing || !section ) {
        return { x, y }
    }
    const sId                       = section.getAttribute("id")
    
    
    const contElement               = landing.querySelector( `.landing-section-container.landing-gap[id="${sId}"] .landing-data-components-container` )!
    const landingPosition: DOMRect  = landing.getBoundingClientRect()
    const sectionPosition: DOMRect  = contElement.getBoundingClientRect()
    x                               = -sectionPosition.x + x
    y                               = -sectionPosition.y + y
    
    console.log( sectionPosition, { x, y } )
    return { x, y }
}